import { QuestionSpecification } from './../client-questions';
import { PaymentType } from './../enums';
import { EntityProperty, QuestionType, TypeSpecification } from '../enums';
import { UserInfoViewModel } from '../optional-benefits/benefit-view.model';


export class CarModel {
  id: number;
  makeId: number;
  modelId: number;
  modelYear: number;
  trim: string;

  constructor(values?: any) {
    Object.assign(this, values);
  }
}

export class UserViewModel {
  id: string;
  name: string;
  email: string;
  phone: string;
  nationality: string;
  dateOfBirth: string;
  car: CarModel;

  constructor(values?: any) {
    Object.assign(this, values);
    this.car = values && values.car ? new CarModel(values.car) : null;
  }
}

export class HoorayViewModel {
  content: string;
}

export class CongratulationViewModel {
  content: string;
  userInfo: UserInfoViewModel;
  premium: number;
  tax: number;
  subtotal: number;
  total: number;
  invoiceNumber: string;
  compareIdentifier: string;
  stampDuty: number;

  constructor(values?: any) {
    Object.assign(this, values);
    this.userInfo = new UserInfoViewModel(values ? values.userInfo : {});
  }

}

export class ComparisonAnswers {
  userId: number;
  companyId: number;
  compareIdentifier: string;
  typeId: number;
  specification: TypeSpecification;
  customAnswers: CustomAnswerModel[];
  profileAnswers: CustomAnswerModel[][];
  specialAnswers: SpecialAnswerModel[];
  additionalAnswer: AdditionalAnswerModel[];

  constructor(values?: any) {
    Object.assign(this, values);
    this.customAnswers = values && values.customAnswers ? values.customAnswers.map(x => new CustomAnswerModel(x)) : [];
    this.specialAnswers = values && values.specialAnswers ? values.specialAnswers.map(x => new SpecialAnswerModel(x)) : [];
    this.additionalAnswer = values && values.additionalAnswer ? values.additionalAnswer.map(x => new AdditionalAnswerModel(x)) : [];
    this.profileAnswers = values && values.profileAnswers ? values.profileAnswers.map(x => x.map(y => new CustomAnswerModel(y))) : [];
  }

  public isSelectedCustomAnswerByAnswerId(answerId: number, optionId: number) {
    if (this.customAnswers.length > 0) {
      return !!this.customAnswers.find(x => {
        if (x.optionId) {
          return x.questionId === answerId && x.optionId === optionId;
        } else if (x.optionsId) {
          return x.optionsId.some(x => x === optionId)
        }
      });
    }
    return false;
  }
}

export class CustomAnswerModel {
  questionId: number;
  type: QuestionType;
  specification: QuestionSpecification;
  optionId: number;
  text: string;
  date: string;
  digit: number;
  optionsId: number[];

  constructor(values: any) {
    Object.assign(this, values);
  }
}

export class SpecialAnswerModel {
  questionId: number;
  property: EntityProperty;
  answer: any;

  constructor(values: any) {
    Object.assign(this, values);
  }
}

export class AdditionalAnswerModel {
  companyId: number;
  additionalId: number;
  isSelected: boolean;
  inputValue: number;

  constructor(values: any) {
    Object.assign(this, values);
  }
}

export class UserCreateResult {
  userId: string;
  email: string;
  status: PaymentType;

  constructor(values: any) {
    Object.assign(this, values);
  }
}
